import { render, staticRenderFns } from "./platform_user_performance_record.vue?vue&type=template&id=6cb5373f"
import script from "./platform_user_performance_record.vue?vue&type=script&lang=js"
export * from "./platform_user_performance_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports